import { hideModal, showModal } from "global/context/action/modal/modal";
import { GlobalContext } from "global/context/Provider";
import { useContext, useEffect, useState } from "react";
import AlertIconFilled from "_+_Portal/assets/images/generico/AlertIconFilled";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import CardAusente from "_+_Portal/_-_Autocheckin/components/genericos/CardAusente/CardAusente";
import CardCheck from "_+_Portal/_-_Autocheckin/components/genericos/CardCheck/CardCheck";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import ModalAutoT from "_+_Portal/_-_Autocheckin/components/genericos/ModalAutoT/ModalAutoT";
import ModalErrorAutoT from "_+_Portal/_-_Autocheckin/components/genericos/ModalErrorAutoT/ModalErrorAutoT";
import { filaVirtualReset } from "_+_Portal/_-_Autocheckin/context/action/filaVirtual";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { wsGetTurnosPacienteDelDiaQr } from "_+_Portal/_-_Autocheckin/context/action/turnosAutoCheckIn";
import { setTurnosSeleccionado } from "_+_Portal/_-_Autocheckin/context/action/turnosSeleccionados";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  BodyContainerP5,
  ButtonP5,
  ContainerButton,
  ContainerP5,
  ContainerSinTurno,
} from "./localStyle";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import { OrderTurnos } from "../PagesFun";
import { showToaster } from "global/context/action/toaster/toaster";
import ModalCentro from "_+_Portal/_-_Autocheckin/components/genericos/ModalCentro/ModalCentro";
import ScrollArrows from "_+_Portal/components/Genericos/ScrollArrows/ScrollArrows";
import { getLocalStorage } from "global/utils/safeJsonParse";
import { mismoCentro, normalizarIdCentro } from "global/utils/idCentro";
import { filtrarTurnosBloqueadosMoron } from "_+_Portal/_-_Autocheckin/utils/filtroMoron";

const TurnosDelDia = () => {
  // -------------------------  useContex  ----------------------------
  const {
    turnosAutoCheckInState,
    turnosSeleccionadosDispatch,
    pasoDispatch,
    turnosAutoCheckInDispatch,
    filaVirtualDispatch,
    puntoControlDispatch,
    textosAutoCheckinState,
  } = useContext(AutocheckContext);
  const { modalDispatch, toasterDispatch } = useContext(GlobalContext);
  // -------------------------  useContex  ----------------------------

  // -------------------------  constants  ----------------------------
  const config = getLocalStorage("config", {});

  let initialData = turnosAutoCheckInState.turnosAutoCheckIn?.data;
  if (initialData !== false && Array.isArray(initialData)) {
    initialData = initialData.filter((e) => !e.presente);
  }
  let filtroHorario =
    textosAutoCheckinState.textosAutoCheckin?.data?.filtroHorario?.orden;
  let minutosToleranciaRecepcion = config?.minutosToleranciaRecepcion;
  let minRecepcionVariosTurnos = config?.minRecepcionVariosTurnos;
  let descHorario =
    textosAutoCheckinState.textosAutoCheckin?.data?.filtroHorario?.descripcion;
  const centroQR = sessionStorage.getItem("centroID");
  // Centros donde OSDE no está habilitado para self-service (configurable
  // desde public/config.json sin recompilar; fallback hardcoded por las dudas).
  let centrosArray = config?.centrosBloqueoOsde ?? [
    29, 21, 20, 17, 5, 16, 23, 15,
  ];

  // -------------------------  constants  ----------------------------

  // -------------------------  useStates  ----------------------------
  const [turnos, setTurnos] = useState(initialData);
  const [loading, setLoading] = useState(true);
  // -------------------------  useStates  ----------------------------

  // -------------------------  funciones  ----------------------------
  const handleClickButton = () => {
    // No te olvides de el error horario
    let turnosRechazados = turnos.filter((e) => !e.checkin);
    let turnosSeleccionados = turnos.filter(
      (e) => e.selected && !(e.type === "ausente") && e.checkin,
    );
    let turnosSinAusente = turnos.filter(
      (e) => !(e.type === "ausente") && mismoCentro(e.idCentro, centroQR),
    );

    if (turnosRechazados.length > 0) {
      setTurnosSeleccionado(turnosRechazados)(turnosSeleccionadosDispatch);
      setLoading(true);
      const idTipoPuntoControl = 6;
      setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
      setPaso("PuntoControl")(pasoDispatch);
    } else if (turnosSeleccionados.length > 0) {
      setTurnosSeleccionado(turnosSeleccionados)(turnosSeleccionadosDispatch);
      if (turnosSeleccionados.length < turnosSinAusente.length) {
        showModalDiaHoy(
          <ModalAutoT
            dissmiss={dissmiss}
            desc={
              "Seleccionaste un solo turno. ¿Deseás avanzar únicamente con la recepción de este turno?"
            }
            title={"Recepción"}
            textBtnOne={"SI"}
            textBtnTwo={"NO"}
            handleChange={{
              btnOne: () => {
                dissmiss();
                setPaso("NumeroAfiliado")(pasoDispatch);
              },
              btnTwo: () => {
                dissmiss();
              },
            }}
          />,
          "Información",
        );
      } else {
        let turnosCentro = turnosSeleccionados.filter((e) =>
          mismoCentro(e.idCentro, centroQR),
        );
        if (turnosCentro.length === 0) {
          //lo mando al primero, no tengo forma con los cambios que pidio gabi.b
          sessionStorage.setItem(
            "otroCentro",
            JSON.stringify(turnosSeleccionados[0].coordenadaGps),
          );
          setPaso("OtroCentro")(pasoDispatch);
        } else {
          setPaso("NumeroAfiliado")(pasoDispatch);
        }
      }
    } else {
      // Verifico si hay turnos disponibles (que no sean ausentes)
      let turnosDisponibles = turnos.filter((e) => e.type !== "ausente");

      if (turnosDisponibles.length === 0 && turnos.length > 0) {
        // Todos los turnos son ausentes
        showModalDiaHoy(
          <ModalErrorAutoT
            dissmiss={dissmiss}
            errorMsg={
              "Sus turnos fueron marcados como ausente, diríjase a la recepción."
            }
          />,
        );
      } else {
        // Hay turnos disponibles pero no seleccionó ninguno
        showModalDiaHoy(
          <ModalErrorAutoT
            dissmiss={dissmiss}
            errorMsg={"Debe seleccionar al menos un turno."}
          />,
        );
      }
    }
  };

  const volver = () => {
    setPaso("Home")(pasoDispatch);
  };

  const dissmiss = () => {
    hideModal()(modalDispatch);
  };

  const showModalDiaHoy = (content, title) => {
    showModal(
      content,
      title,
      dissmiss,
      false,
      {},
      "centro",
      true,
    )(modalDispatch);
  };

  const handleSeleccionar = (item, isSelected) => {
    if (!mismoCentro(item.idCentro, centroQR)) {
      console.error("[CheckinQR] Centro mismatch al seleccionar turno", {
        itemIdCentro: item.idCentro,
        itemIdCentroType: typeof item.idCentro,
        centroQR,
        centroQRType: typeof centroQR,
        dataComplete: localStorage.getItem("dataComplete"),
        idTerminal: localStorage.getItem("idTerminal"),
      });
      showModal(
        <ModalCentro item={item} />,
        "Turno en otra sede",
        dissmiss,
        false,
        {},
        "centro",
        true,
      )(modalDispatch);
    } else {
      const newTurnos = turnos.map((element, key) => {
        if (element.idturno === item.idturno) {
          if (element?.type === "fueraRangoHorario") {
            showToaster(
              {
                texto: descHorario,
                tipo: "danger",
              },
              "centroArriba",
            )(toasterDispatch);
          } else {
            element.selected = isSelected;
          }
        }
        return element;
      });
      setTurnos(newTurnos);
    }
  };
  // -------------------------  funciones  ----------------------------

  // -------------------------  useEffect  ----------------------------
  useEffect(() => {
    let nextStep = (isCorrect, data) => {
      if (isCorrect && data) {
        data = data.filter((e) => !e.presente);

        const turnosOrdenados = OrderTurnos(
          data,
          filtroHorario,
          minutosToleranciaRecepcion,
          minRecepcionVariosTurnos,
          false,
        );

        const kinesioVerificaRecepcion = turnosOrdenados.filter(
          (turno) => turno.type === "kinesioVerificacion",
        );
        const osValidacionInterna = turnosOrdenados.filter(
          (turno) => turno.type === "osValidacionInterna",
        );
        const noPermiteCheckIn = turnosOrdenados.filter(
          (turno) => turno.type === "noPermiteCheckIn",
        );
        const practicas = turnosOrdenados.filter(
          (turno) => turno.type === "practica",
        );

        if (kinesioVerificaRecepcion.length > 0) {
          setTurnosSeleccionado(kinesioVerificaRecepcion)(
            turnosSeleccionadosDispatch,
          );
          const idTipoPuntoControl = 12;
          setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
          setPaso("PuntoControl")(pasoDispatch);
        } else if (osValidacionInterna.length > 0) {
          setTurnosSeleccionado(osValidacionInterna)(
            turnosSeleccionadosDispatch,
          );
          const idTipoPuntoControl = 13;
          setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
          setPaso("PuntoControl")(pasoDispatch);
        } else if (noPermiteCheckIn.length > 0) {
          setTurnosSeleccionado(noPermiteCheckIn)(turnosSeleccionadosDispatch);
          const idTipoPuntoControl = 1;
          setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
          setPaso("PuntoControl")(pasoDispatch);
        }
        //  else if (practicas.length > 0) {
        //   setTurnosSeleccionado(practicas)(turnosSeleccionadosDispatch);
        //   const idTipoPuntoControl = 2;
        //   setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
        //   setPaso("PuntoControl")(pasoDispatch);
        // }
        else {
          // Restricción OSDE: turnos con aSuCargo=0 en centros de la lista
          // requieren atención presencial. Si TODOS los turnos del paciente
          // caen en esa regla, mandamos a PuntoControl. Si al menos uno NO
          // está bloqueado, lo dejamos seguir solo con los habilitados.
          // VERIFICAR: nombre del campo `aSuCargo` (¿está en turno o en
          // turno.resumen?) y el idTipoPuntoControl correcto para este caso.
          // Filtrado por turno (no por paciente): usamos `obra_social` del
          // turno, que viene exactamente como "OSDE" (no "OSDE BINARIO" como
          // viene en `coberturaDto.cobertura`).
          // `asucargo` puede venir como "0", 0 o null/undefined.
          // `idCentro` puede venir como string o number → normalizamos.
          const aSuCargoEsCero = (valor) =>
            valor == null || Number(valor) === 0;
          const turnosOsdeBloqueados = turnosOrdenados.filter(
            (t) =>
              t.obra_social === "OSDE" &&
              aSuCargoEsCero(t.asucargo) &&
              centrosArray.includes(normalizarIdCentro(t.idCentro)),
          );
          // Reglas específicas de Morón (kinesio, tomografía, punción
          // tiroides). Vive en otro archivo porque solo aplica a ese centro.
          const turnosMoronBloqueados = filtrarTurnosBloqueadosMoron(
            turnosOrdenados,
            centroQR,
          );
          // Unión sin duplicados: un turno podría matchear ambas reglas.
          const turnosBloqueados = [
            ...new Set([...turnosOsdeBloqueados, ...turnosMoronBloqueados]),
          ];

          const turnosDisponibles = turnosOrdenados.filter(
            (t) => !turnosBloqueados.includes(t),
          );

          if (
            turnosOrdenados.length > 0 &&
            turnosBloqueados.length > 0 &&
            turnosDisponibles.length === 0
          ) {
            setTurnosSeleccionado(turnosBloqueados)(
              turnosSeleccionadosDispatch,
            );
            // Mensaje según la regla que disparó el bloqueo. Si hay turnos
            // bloqueados por Morón, ese mensaje gana (es más específico que
            // el de OSDE).
            let idTipoPuntoControl = 22;
            let mensaje =
              "Lamentablemente OSDE no nos habilitó para atender en este centro. Podemos ofrecerle atención en otro de nuestros centros.";
            setIdTipoPuntoControl(
              idTipoPuntoControl,
              mensaje,
            )(puntoControlDispatch);
            setPaso("PuntoControl")(pasoDispatch);
          } else {
            setLoading(false);
            setTurnos(turnosDisponibles);
          }
        }
      } else {
        setLoading(false);
      }
    };

    if (loading) {
      wsGetTurnosPacienteDelDiaQr(nextStep)(turnosAutoCheckInDispatch);
    }
    filaVirtualReset()(filaVirtualDispatch);
  }, []);
  // -------------------------  useEffect  ----------------------------

  return (
    <>
      <Loading
        dataLoading={loading}
        color="c-white"
        descripcion={"Cargando..."}
      />

      <LayoutPasos
        volverTo={"/autocheckin"}
        handleClick={volver}
        title={"TENGO TURNO"}
        subtitle={
          "Éstos son tus turnos para hoy. Tocá 'Recepcionarme' para comenzar con el proceso."
        }
      >
        {!loading && (
          <ContainerP5
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            <BodyContainerP5 className="turnos-scroll-body">
              {turnos
                ? turnos.map((element, key) => {
                    if (element?.type === "ausente") {
                      return (
                        <CardAusente
                          title={element.especialidad}
                          horario={element.hora}
                          sede={element.centro}
                          medico={element.medico}
                          key={key}
                          setTurnos={setTurnos}
                          turnos={turnos}
                          id={element.idturno}
                          actived={element.selected}
                          flgSoloConsulta={element.flgSoloConsulta}
                        />
                      );
                    } else {
                      return (
                        <CardCheck
                          title={element.especialidad}
                          horario={element.hora}
                          sede={element.centro}
                          medico={element.medico}
                          key={key}
                          setTurnos={setTurnos}
                          turnos={turnos}
                          id={element.idturno}
                          actived={element.selected}
                          flgSoloConsulta={element.flgSoloConsulta}
                          setSelected={(isSelected) =>
                            handleSeleccionar(element, isSelected)
                          }
                        />
                      );
                    }
                  })
                : ""}

              {!turnos || turnos.length === 0 ? (
                <ContainerSinTurno>
                  <AlertIconFilled
                    height={"70"}
                    width={"70"}
                    color={"var(--color-latex10)"}
                  />
                  <span className="title">
                    No se encontraron turnos para el día de hoy
                  </span>
                </ContainerSinTurno>
              ) : (
                ""
              )}
            </BodyContainerP5>
            {!loading && turnos && turnos.length > 0 && (
              <ContainerButton>
                <ButtonP5 onClick={handleClickButton}>Recepcionarme</ButtonP5>
              </ContainerButton>
            )}
            <ScrollArrows targetSelector=".turnos-scroll-body" />
          </ContainerP5>
        )}
      </LayoutPasos>
    </>
  );
};

export default TurnosDelDia;
